class Materiallist {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-materiallist="scope"]',
			submit: '[data-materiallist="submit"]',
			item: '[data-materiallist="item"]',
			summary: '[data-materiallist="summary"]',
			loader: '[data-materiallist="loader"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('change', this.config.item, (event) => this.doRequest(event, 0));
		this.$scope.on('click', this.config.submit, (event) => this.doRequest(event, 1));
	}

	doRequest(event, save = 0) {
		let $target = $(event.currentTarget);
		let $scope = $target.closest(this.config.scope);
		$scope.find(this.config.loader).addClass('loading');

		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			let $items = $scope.find(this.config.item);

			let data = {
				action: 'changeMaterials',
				group: $scope.data('group'),
				save: save,
				materials: {}
			};

			$items.each((index, element) => {
				let $element = $(element);
				let productId = $element.data('id');
				let amount = $element.val();
				data['materials'][productId] = amount;
			});

			$.ajax({
				url: window.location.href,
				method: 'post',
				data: data,
				success: this.onSuccess.bind(this, $scope, save)
			})
		}, 200);
	}

	onSuccess($scope, save, response) {
		$scope.find(this.config.summary).html(response.summary);

		if(save) {
			window.location.reload();
			return;
		}

		$scope.find(this.config.loader).removeClass('loading');
	}
}

export default Materiallist;